export enum TextVariant {
    Dark = 'dark',
    Light = 'light',
}
